import dayjs from "dayjs"

export const Home3 = () => {
  console.log(dayjs())
  return <><div>hom3</div></>
}